import React from "react";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomerCardTable from "./components/CustomerCardTable";
import HeaderContent from "../../components/layout/components/HeaderContent";

const CustomerCardList = () => {
  const breadcrumb = [
    { link: "/customerCards", title: "Parents with Due Balance" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Parents with Due Balance"
        isNotHaveSchoolFilter
      />

      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Customer Card List</Typography>
        </Grid>

        <Grid item xs={12}>
          <CustomerCardTable isAutoHeight />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default CustomerCardList;
